import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["actionGroup", "metadata", "position", "subtitle", "testId", "text", "icon", "title", "metadataPosition", "hideIcon"];
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { SmartLinkAlignment, SmartLinkDirection, SmartLinkPosition, SmartLinkWidth } from '../../../../../../constants';
import { LinkIcon } from '../../../elements';
import Block from '../../block';
import ElementGroup from '../../element-group';
import { renderElementItems } from '../../utils';
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */
var TitleBlockResolvedViewOld = function TitleBlockResolvedViewOld(_ref) {
  var actionGroup = _ref.actionGroup,
    _ref$metadata = _ref.metadata,
    metadata = _ref$metadata === void 0 ? [] : _ref$metadata,
    position = _ref.position,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? [] : _ref$subtitle,
    testId = _ref.testId,
    text = _ref.text,
    icon = _ref.icon,
    title = _ref.title,
    metadataPosition = _ref.metadataPosition,
    hideIcon = _ref.hideIcon,
    blockProps = _objectWithoutProperties(_ref, _excluded);
  var metadataElements = renderElementItems(metadata);
  var subtitleElements = renderElementItems(subtitle);
  return /*#__PURE__*/React.createElement(Block, _extends({}, blockProps, {
    testId: "".concat(testId, "-resolved-view")
  }), !hideIcon && /*#__PURE__*/React.createElement(LinkIcon, {
    overrideIcon: icon,
    position: position
  }), /*#__PURE__*/React.createElement(ElementGroup, {
    direction: SmartLinkDirection.Vertical,
    width: SmartLinkWidth.Flexible,
    overrideCss: css({
      gap: "var(--ds-space-050, 0.25rem)"
    })
  }, title, subtitleElements && /*#__PURE__*/React.createElement(ElementGroup, {
    direction: SmartLinkDirection.Horizontal
  }, subtitleElements)), metadataElements && /*#__PURE__*/React.createElement(ElementGroup, {
    direction: SmartLinkDirection.Horizontal,
    align: SmartLinkAlignment.Right,
    position: metadataPosition !== null && metadataPosition !== void 0 ? metadataPosition : SmartLinkPosition.Center
  }, metadataElements), actionGroup);
};
export default TitleBlockResolvedViewOld;